import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { TokenManagerService } from '../services/token-manager.service';
import { UsersService } from '../services/users.service';
import { AccountService } from '../services/account.service';

export const authGuard: CanActivateFn = (route, state) => {
    const userService = inject(UsersService);
    const accountService = inject(AccountService);
    const tokenManager = inject(TokenManagerService);
    const router = inject(Router);
    const user = userService.currentUser();

    if (tokenManager.isLogged() && user) {
        console.log(route.routeConfig?.path);
        if(user.passwordExpired && route.routeConfig?.path !== 'account/alterar-senha') {
            router.navigate(['account/alterar-senha'])   
            return false;
        }
        return of(true);
    } else {
        accountService.logout();
        return false;
    }
};
